import React from "react";
import "./Contractdocumentation.css";

import logoimage from "../../assets/ايجار-1.png";
const Contractdocumentation = () => {
  return (
   <>
    <div className="head">
    <h3>يمكنك الحصول على عقدك الموثق من شبكة إيجار من أي مكان في المملكة</h3>
      <h2>طلب سكني | طلب تجاري</h2>
    </div>
    <img
        src={logoimage}
        alt="Real Estate Consulting"
        className="hero-image"
      />
      </>
     
        
       );
    };
    
    export default Contractdocumentation ;